export default "__VITE_ASSET__BF7iH_IG__"